export const ORDER_CREATE_REQUEST = 'ORDER_CREATE_REQUEST'
export const ORDER_CREATE_SUCCESS = 'ORDER_CREATE_SUCCESS'
export const ORDER_CREATE_FAIL = 'ORDER_CREATE_FAIL'

export const ORDER_CREATE_RESET = "ORDER_CREATE_RESET";

export const ORDER_DETAILS_REQUEST = 'ORDER_DETAILS_REQUEST'
export const ORDER_DETAILS_SUCCESS = 'ORDER_DETAILS_SUCCESS'
export const ORDER_DETAILS_FAIL = 'ORDER_DETAILS_FAIL'

export const ORDER_COMPLETE_REQUEST = 'ORDER_COMPLETE_REQUEST'
export const ORDER_COMPLETE_SUCCESS = 'ORDER_COMPLETE_SUCCESS'
export const ORDER_COMPLETE_FAIL = 'ORDER_COMPLETE_FAIL'
export const ORDER_COMPLETE_RESET = 'ORDER_COMPLETE_RESET'

export const RESTAURANT_ORDERS_REQUEST = 'RESTAURANT_ORDERS_REQUEST'
export const RESTAURANT_ORDERS_SUCCESS = 'RESTAURANT_ORDERS_SUCCESS'
export const RESTAURANT_ORDERS_FAIL = 'RESTAURANT_ORDERS_FAIL'

export const ORDER_TRACK_REQUEST = 'ORDER_TRACK_REQUEST'
export const ORDER_TRACK_SUCCESS = 'ORDER_TRACK_SUCCESS'
export const ORDER_TRACK_FAIL = 'ORDER_TRACK_FAIL'